import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/WhyEasyDropTaxi.css';

const FEATURES = [
  {
    icon: 'fa-map-marker',
    title: 'Coimbatore Based',
    text: 'Based in Coimbatore, with journeys across South India.',
  },
  {
    icon: 'fa-road',
    title: 'Intercity Travel',
    text: 'Cities, airports, hill stations, and pilgrimage routes.',
  },
  {
    icon: 'fa-car',
    title: 'Multiple Cab Options',
    text: 'Sedan, SUV, and Crysta for different group sizes.',
  },
  {
    icon: 'fa-tag',
    title: 'Transparent Fare Estimates',
    text: 'Check the estimated fare before you confirm.',
  },
];

const COVERAGE = ['Tamil Nadu', 'Kerala', 'Karnataka', 'Puducherry', 'Andhra Pradesh'];

const WhyEasyDropTaxi = () => (
  <section className="brand-about block-space" aria-labelledby="why-easydroptaxi-heading">
    <div className="container">
      <div className="brand-about-layout">
        <div className="brand-about-copy">
          <p className="brand-about-kicker">
            <span aria-hidden="true"></span>
            About EasyDropTaxi
          </p>
          <h2 id="why-easydroptaxi-heading">Your Journey, Our Priority.</h2>
          <p>
            EasyDropTaxi makes intercity travel simple, comfortable and convenient with reliable taxi booking services across South India.
          </p>
          <p>
            Based in Coimbatore, Tamil Nadu, we connect travellers to cities, airports, hill stations and popular destinations through convenient one-way drops, round trips, airport transfers and outstation journeys.
          </p>
          <p>
            Whether you&apos;re travelling for business, family holidays or a pilgrimage, we help you find the right cab for your journey with convenient booking options and transparent fare estimates.
          </p>

          <div className="brand-about-features">
            {FEATURES.map((feature) => (
              <article key={feature.title} className="brand-about-card">
                <i className={`fa ${feature.icon}`} aria-hidden="true"></i>
                <h3>{feature.title}</h3>
                <p>{feature.text}</p>
              </article>
            ))}
          </div>

          <p className="brand-about-coverage">
            {COVERAGE.map((place, index) => (
              <React.Fragment key={place}>
                {index > 0 ? <span aria-hidden="true"> | </span> : null}
                {place}
              </React.Fragment>
            ))}
          </p>

          <Link className="brand-about-cta" to="/services">
            Explore Our Services
          </Link>
        </div>

        <figure className="brand-about-media">
          <img
            src="/images/abus-pic.jpg"
            alt="Adiyogi Shiva statue, a South India pilgrimage destination"
            width="1280"
            height="720"
            loading="lazy"
            decoding="async"
          />
        </figure>
      </div>
    </div>
  </section>
);

export default WhyEasyDropTaxi;
